<a
  href="javascript:void(0)"
  (click)="handleClick()"
  class="rs-link-no-decoration"
  data-tms-event="link-click"
  attr.data-tms-link-zone="{{ productType }} options"
  attr.data-tms-link-name="{{ option?.name }}"
  attr.data-cy="{{ 'productOption-' + option?.optionCodeForDescription }}"
>
  <div class="panel rs-panel-clickable rs-border" *ngIf="!option?.optionCategoryImage">
    <div class="rs-flex-row rs-flex-middle">
      <div class="rs-flex-column">
        <div class="rs-flex-row rs-flex-middle">
          <div class="rs-flex-columns rs-flex-grow">
            <p class="rs-txt-purple rs-font-pxB">{{ option?.name }}</p>
          </div>
          <div class="rs-flex-columns">
            <p class="text-right">
              <mprd-price
                *ngIf="optionType == OptionType.OPTION"
                [option]="option"
                [isPending]="pendingOrder || isPendingInCart"
                [showPriceForIncluded]="isConfigurableOption"
                data-cy="optionPrice"
              ></mprd-price>
            </p>
          </div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
        <span class="rs-panel-clickable-arrow" aria-hidden="true"></span>
      </div>
    </div>
  </div>

  <div
    *ngIf="option?.optionCategoryImage"
    class="rs-panel-flex rs-panel-clickable rs-border rs-bg-c2 rs-pos-rel rs-overflow-visible rs-mh-m13 rs-mh-l16"
  >
    <div
      *ngIf="isAsOrAsasOptionPromo"
      class="rs-padding-mini rs-no-padding-right-s rs-pos-tr rs-margin-top2-neg rs-margin-right1"
    >
      <div class="rs-padding-mini rs-no-padding-right-s">
        <mprd-patch [patchShape]="'bottom-right'" [patchType]="'promo'">
          {{ 'tv.option.patch.promo' | translate }}
        </mprd-patch>
      </div>
    </div>
    <div
      *ngIf="option?.trialOption && !isActiveTrialOption"
      class="rs-padding-mini rs-no-padding-right-s rs-pos-tr rs-margin-top2-neg rs-margin-right1"
    >
      <div class="rs-padding-mini rs-no-padding-right-s">
        <div class="rs-patch-webdeal rs-patch-corner2" data-cy="optionPatch">
          <div class="rs-patch-content text-center">
            <ng-container *ngIf="!option?.tryAndBuyFreeFor3Months">
              {{ 'tv.active.options.try.and.buy' | translate }}
            </ng-container>
            <ng-container *ngIf="option?.tryAndBuyFreeFor3Months">
              {{ 'tv.active.options.try.and.buy.3months' | translate }}
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-panel-flex-cell rs-no-padding">
      <div class="rs-flex-row rs-flex-collapse rs-maxh">
        <!--        <px-alert [alertKey]="getAlertKey()"></px-alert>-->
        <!-- MPRD-5394 wait for design from Quentin -->
        <div class="small-12 medium-4 rs-flex-columns">
          <div
            class="rs-panel-flex-cell-big rs-bgi-cover-cc rs-maxh rs-mh-s11 rs-radius rs-no-radius-bottom-so rs-no-radius-right-m"
            attr.data-interchange="{{ optionCategoryImageClass }}"
            data-cy="optionImage"
          ></div>
        </div>
        <div class="small-12 medium-8 rs-flex-columns">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column">
              <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                <div class="rs-txt-c1 rs-padding-bottom1">
                  <p class="rs-txt-purple rs-font-pxB rs-padding-bottom1" data-cy="optionName">
                    {{ option?.name }}
                  </p>
                  <p *ngIf="showActiveTvBonusMessage" class="rs-padding-bottom1">
                    {{ 'tv.options.active.bonus' | translate }}
                  </p>
                  <p *ngIf="showEligibleTvBonusMessage" class="rs-padding-bottom1">
                    {{ 'tv.options.eligible.bonus' | translate }}
                  </p>
                  <p *ngIf="isActiveTrialOption" class="rs-padding-bottom1">
                    <ng-container *ngIf="option?.trialOption.endOfTrialDecision === 'CTP'">
                      <span class="rs-price-s rs-price-promo">
                        <span class="rs-euro">{{ 'price.freeLabel' | translate }}</span>
                      </span>
                      {{ 'trial.message.beforeDate' | translate }}
                      <strong>{{
                        option?.trialOption?.deactivationDate | date: 'dd/MM/yyyy'
                      }}</strong
                      >,<br />{{ 'trial.message.beforePrice.optedIn' | translate }}
                      <px-currency-amount [amount]="priceTrialOption" [amountClass]="'rs-price-s'">
                      </px-currency-amount>
                      {{ option.trialOption | chargeFrequency: 'chargeFrequency' }}
                    </ng-container>
                    <ng-container *ngIf="option?.trialOption.endOfTrialDecision === 'NCTP'">
                      <span class="rs-price-s rs-price-promo">
                        <span class="rs-euro">{{ 'price.freeLabel' | translate }}</span>
                      </span>
                      {{ 'trial.message.beforeDate' | translate }}
                      <strong>{{
                        option?.trialOption?.deactivationDate | date: 'dd/MM/yyyy'
                      }}</strong>
                      {{ 'trial.message.beforePrice.optedOut' | translate }}
                      <px-currency-amount [amount]="priceTrialOption" [amountClass]="'rs-price-s'">
                      </px-currency-amount>
                      {{ option.trialOption | chargeFrequency: 'chargeFrequency' }}
                    </ng-container>
                  </p>
                  <p
                    *ngIf="
                      !(pendingOrder || isPendingInCart) &&
                      option?.trialOption?.endOfTrialDecision === 'CTP'
                    "
                    class="rs-padding-bottom1"
                  >
                    <span class="rs-txt-success rs-font-pxB"
                      ><i class="icon-Status-ok rs-margin-right1" aria-hidden="true"></i
                      >{{ 'tv.active.options.try.and.buy.optedin' | translate }}</span
                    >
                  </p>

                  <p
                    *ngIf="
                      !(pendingOrder || isPendingInCart) &&
                      option?.trialOption?.endOfTrialDecision === 'NCTP'
                    "
                    class="rs-padding-bottom1"
                  >
                    <span class="rs-txt-warning rs-font-pxB"
                      ><i class="icon-Status-warning rs-margin-right1" aria-hidden="true"></i
                      >{{ 'tv.active.options.try.and.buy.optedout' | translate }}</span
                    >
                  </p>
                  <p
                    *ngIf="optionType == OptionType.OPTION && !option?.trialOption"
                    class="rs-padding-bottom1"
                  >
                    <mprd-price
                      [option]="option"
                      [isPending]="pendingOrder || isPendingInCart"
                      [amountClass]="'rs-price-s'"
                      data-cy="optionPrice"
                    ></mprd-price>
                  </p>
                  <p
                    *ngIf="option?.trialOption && !isActiveTrialOption && priceTrialOption"
                    class="rs-padding-bottom1"
                    data-cy="tvTrialAvailablePrice"
                  >
                    <ng-container *ngIf="!option?.tryAndBuyFreeFor3Months">
                      {{ 'trial.message.available.join' | translate }}
                    </ng-container>
                    <ng-container *ngIf="option?.tryAndBuyFreeFor3Months">
                      {{ 'trial.message.available.join.3months' | translate }}
                    </ng-container>
                    <br />
                    {{ 'trial.message.available.then' | translate }}
                    <px-currency-amount
                      [amount]="priceTrialOption"
                      [amountClass]="'rs-price-s'"
                    ></px-currency-amount>
                    {{ option.trialOption | chargeFrequency: 'chargeFrequency' }}
                  </p>
                  <p
                    *ngIf="showNetflixBSWarning"
                    class="rs-padding-bottom1"
                    data-cy="tvNetflixBsWarning"
                  >
                    <span class="rs-txt-warning rs-font-pxB"
                      ><i class="icon-Status-warning rs-margin-right1" aria-hidden="true"></i
                      >{{ 'tv.options.netflixBS.warning' | translate }}</span
                    >
                  </p>
                  <p
                    *ngIf="showDisneyPlusBSWarning"
                    class="rs-padding-bottom1"
                    data-cy="tvDisneyPlusBsWarning"
                  >
                    <span class="rs-txt-warning rs-font-pxB"
                      ><i class="icon-Status-warning rs-margin-right1" aria-hidden="true"></i
                      >{{ 'tv.options.DisneyPlusBS.warning' | translate }}</span
                    >
                  </p>
                  <p
                    *ngIf="(pendingOrder || isPendingInCart) && option?.trialOption"
                    class="rs-padding-bottom1"
                  >
                    <span class="rs-font-pxB rs-txt-warning">
                      <i class="icon-Stopwatch rs-margin-right1" aria-hidden="true"></i>
                      {{ 'common.options.pending' | translate }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <span
                class="rs-panel-clickable-arrow rs-no-margin-bottom rs-margin-right2"
                aria-hidden="true"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</a>
